import { render, staticRenderFns } from "./QRHome.vue?vue&type=template&id=71568fc1"
import script from "./QRHome.vue?vue&type=script&lang=js"
export * from "./QRHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71568fc1')) {
      api.createRecord('71568fc1', component.options)
    } else {
      api.reload('71568fc1', component.options)
    }
    module.hot.accept("./QRHome.vue?vue&type=template&id=71568fc1", function () {
      api.rerender('71568fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/qrCode/QRHome.vue"
export default component.exports